import PropTypes from 'prop-types';
import { Component } from 'react';
import { popoutPlayer } from 'src/client/popout';
import PopoutIconSolid from '../../shared/svgIcons/player/PopoutIconSolid';

/**
 * Renders a popout button for external player
 *
 * @param {string} width - The width of the button
 * @param {string} height - The height of the button
 * @param {string} dataTestId - Test ID data attribute to add
 * @param {object} actions - An object representing all available actions
 * @param {function} onClick - Click event handler
 */
export default class PopOutButtonComponent extends Component {
  static propTypes = {
    width: PropTypes.string,
    height: PropTypes.string,
    dataTestId: PropTypes.string.isRequired,
    onClick: PropTypes.func,
  };

  handleClick = () => {
    const { onClick } = this.props;

    popoutPlayer.openOrUpdate();

    if (onClick) {
      onClick();
    }
  };

  /**
   * Render the popout icon
   */
  render() {
    const { width, height, dataTestId } = this.props;

    return (
      <PopoutIconSolid
        width={width}
        height={height}
        dataTestId={dataTestId}
        onClick={this.handleClick}
      />
    );
  }
}

export const PopOutButton = PopOutButtonComponent;
